import React from 'react'
import PropTypes from 'prop-types'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  OptionCounterparty,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Trade.style'
import { Box, Typography } from '@mui/material'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import { ButtonGroupStyle, OptionContainer, SideButton } from '../../Trade.style'
import {
  CheckboxStyle,
  FormControlLabelStyle,
  Label
} from '../../../../components/styled/global.style'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

const SwapTrade = ({
  form,
  sides,
  counterParty,
  fixingSource,
  handelFormChange,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  errors,
  handelDateChange,
  swapOption,
  checkPrimeBrokerIsRBS
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Counterparty *</Label>
        {Array.isArray(counterParty.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'counterparty'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.counterparty}
            onBlur={handelBlurCurrencyPair}
            options={counterParty.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select CP'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>{form.trade_type.name.includes('Client') ? 'Client' : 'Our'} Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="side"
                key={id}
                value={name}
                select={String(form.side === name)}
                onClick={handelFormChange}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>

      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Leg Quantity *</Label>
        <NumericFormatModal
          value={form.far_leg_quantity}
          name="far_leg_quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Value Date *</Label>
        <TextFieldStyle
          type="date"
          name="value_date"
          value={form.value_date}
          placeholder="dd-mm-yyyy"
          onChange={event => handelDateChange('value_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Value Date *</Label>
        <TextFieldStyle
          type="date"
          name="far_value_date"
          value={form.far_value_date}
          placeholder="dd-mm-yyyy"
          onChange={event => handelDateChange('far_value_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Price *</Label>
        <InputBaseStyle
          value={form.price}
          name="price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Price *</Label>
        <InputBaseStyle
          value={form.far_price}
          name="far_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      {swapOption && (
        <>
          <Box width={'100%'}>
            <Label>Fixing Source *</Label>
            {Array.isArray(fixingSource.data) && (
              <AutocompleteStyle
                onChange={(event, element) => {
                  event.target.name = 'fixing_source'
                  element = element ?? ''
                  handelFormChange(event, element)
                }}
                size={'small'}
                value={form.fixing_source}
                options={fixingSource.data.map(({ name }) => name)}
                renderInput={params => (
                  <TextFieldModalStyle fullWidth {...params} placeholder="Select Fix Source" />
                )}
                ListboxComponent={PaperAutoComplete}
              />
            )}
          </Box>
          <Box width={'100%'}>
            <Label>Fixing Date *</Label>
            <TextFieldStyle
              type="date"
              variant="outlined"
              value={form.fixing_date}
              onChange={event => handelDateChange('fixing_date', event.target.value)}
            />
          </Box>
          <Box width={'100%'}>
            <Label>Far Fixing Date *</Label>
            <TextFieldStyle
              type="date"
              name="far_fixing_date"
              value={form.far_fixing_date}
              placeholder="dd-mm-yyyy"
              onChange={event => handelDateChange('far_fixing_date', event.target.value)}
            />
          </Box>
        </>
      )}
      <Box width={'100%'}>
        <Label>Note</Label>
        <TextFieldStyle
          variant="outlined"
          value={form.note}
          name="note"
          onChange={handelFormChange}
        />
      </Box>
      {checkPrimeBrokerIsRBS && (
        <>
          <Box width={'100%'}>
            <Label>Bdr</Label>
            <InputBaseStyle value={form.bdr} name="bdr" onChange={handelFormChange} />
          </Box>
          <Box
            style={{
              display: 'flex',
              margin: 'inherit'
            }}
          >
            <FormControlLabelStyle
              style={{ color: 'white' }}
              onChange={handelFormChange}
              name="is_pba"
              control={
                <CheckboxStyle
                  style={{ marginRight: '8px' }}
                  checked={form.is_pba}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="PBA"
            />
          </Box>
        </>
      )}
    </>
  )
}

export default SwapTrade

SwapTrade.propTypes = {
  form: PropTypes.object,
  sides: PropTypes.object,
  fixingSource: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  handelDateChange: PropTypes.func,
  errors: PropTypes.object,
  swapOption: PropTypes.bool,
  counterParty: PropTypes.object,
  checkPrimeBrokerIsRBS: PropTypes.bool
}
